import { getTrackingStrings } from 'constants/trackingStrings';

const { closeRemoveStockLotDialog, removeStockLot } = getTrackingStrings();

export const getCopy = () => ({
  closeRemoveStockLotDialog,
  removeStockLot,
});
